import * as yup from 'yup';
import type { TFunction } from 'i18next';
import differenceInDays from 'date-fns/differenceInDays';
import { CreateSynchroForm } from '../../types';

const MAX_RANGE_DAYS = 31;

export const getSchema = (t: TFunction): yup.ObjectSchema<CreateSynchroForm> => {
  const schema = yup.object().shape({
    country: yup.string().required(t('synchro4me.validation.country')),
    stores: yup
      .array()
      .of(yup.object().required())
      .min(1, t('synchro4me.validation.stores'))
      .required(),
    businessDateFrom: yup.date().required(t('synchro4me.validation.businessDateFrom')).nullable(),
    businessDateTo: yup
      .date()
      .required(t('synchro4me.validation.businessDateTo'))
      .nullable()
      .min(yup.ref('businessDateFrom'), t('synchro4me.validation.businessDateToMin'))
      .test(
        'max-range-days',
        t('synchro4me.validation.businessDateToMax', { days: MAX_RANGE_DAYS }),
        function (businessDateTo) {
          const { businessDateFrom } = this.parent;
          if (!businessDateTo || !businessDateFrom) return true;

          const diff = Math.abs(differenceInDays(businessDateTo, businessDateFrom));
          return diff <= MAX_RANGE_DAYS;
        }
      ),
    justification: yup
      .string()
      .required(t('synchro4me.validation.justification'))
      .max(80, t('synchro4me.validation.justificationMax')),
  });

  return schema as unknown as yup.ObjectSchema<CreateSynchroForm>;
};
